import { gql } from 'shared/types/layoutcreator'

export const REUPLOAD_OLD_IMAGE = gql(/* GraphQL */ `
  mutation reuploadOldImage(
    $groupId: String!
    $projectId: String!
    $DAPId: String!
    $DAPValue: String!
  ) {
    reuploadOldImage(
      groupId: $groupId
      projectId: $projectId
      DAPId: $DAPId
      DAPValue: $DAPValue
    ) {
      source
      isFound
      xml
    }
  }
`)

export const START_MIGRATIONS_FOR_RANDOM_PROJECTS =
  gql(/* GraphQL */ `
    mutation startMigrationsForRandomProjects($count: Int!) {
      startMigrationsForRandomProjects(count: $count)
    }
  `)

export const START_PROJECT_MIGRATION = gql(/* GraphQL */ `
  mutation startMigration($projectId: String!) {
    startMigration(projectId: $projectId)
  }
`)

export const REMOVE_MIGRATION_FROM_QUEUE = gql(/* GraphQL */ `
  mutation removeMigrationFromQueue($migrationId: String!) {
    removeMigrationFromQueue(migrationId: $migrationId)
  }
`)

export const EMPTY_MIGRATIONS_QUEUE = gql(/* GraphQL */ `
  mutation emptyMigrationsQueue {
    emptyMigrationsQueue
  }
`)

export const FIX_MISSING_PAGE_INDEXES = gql(/* GraphQL */ `
  mutation fixMissingPageIndexes($projectId: String!) {
    fixMissingPageIndexes(projectId: $projectId)
  }
`)

export const FIX_MISSING_PAGE_TYPES = gql(/* GraphQL */ `
  mutation fixMissingPageTypes($projectId: String!) {
    fixMissingPageTypes(projectId: $projectId)
  }
`)

export const FIX_ALL_PAGE_INDEXES = gql(/* GraphQL */ `
  mutation fixAllPageIndexes {
    fixAllPageIndexes
  }
`)

export const FIX_ALL_PAGE_TYPES = gql(/* GraphQL */ `
  mutation fixAllPageTypes {
    fixAllPageTypes
  }
`)

export const RECOVER_PROJECT_META = gql(/* GraphQL */ `
  mutation recoverProjectMeta(
    $projectName: String!
    $templatePath: String!
    $chilifolderName: String!
    $groupId: String!
    $coverType: String
  ) {
    recoverProjectMeta(
      projectName: $projectName
      templatePath: $templatePath
      chilifolderName: $chilifolderName
      groupId: $groupId
      coverType: $coverType
    )
  }
`)

export const ADD_PAGES_TO_PROJECT = gql(/* GraphQL */ `
  mutation addPagesToProject(
    $projectId: String!
    $documentId: String!
    $index: Int!
    $templatePath: String
    $projectFolderName: String
    $type: String!
  ) {
    addPagesToProject(
      projectId: $projectId
      documentId: $documentId
      index: $index
      templatePath: $templatePath
      projectFolderName: $projectFolderName
      type: $type
    )
  }
`)
